/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TagTypeEnum {
    GUARDIAN = 'guardian',
    COACH = 'coach',
    STUB = 'stub',
}
